import { fetchApi } from '@/config/api'

export interface AdminHipayVendor {
  idVendeur: number
  nomSociete?: string | null
  nomBoutique?: string | null
  email?: string | null
  accountId?: number | null
  accountStatus: string
  bankStatus: string
  kycStatus?: string | null
  kycCheckedAt?: string | null
  uboStatus?: string | null
}

export interface AdminHipayUboStatementResult {
  idVendeur: number
  email: string
  accountId: number
  payload: string
}

const vendorFields = `
  idVendeur nomSociete nomBoutique email accountId accountStatus bankStatus kycStatus kycCheckedAt uboStatus
`

export async function fetchAdminHipayVendors(): Promise<AdminHipayVendor[]> {
  const data = await fetchApi<{ adminEfpHipayVendors: AdminHipayVendor[] }>(
    `query { adminEfpHipayVendors { ${vendorFields} } }`,
  )
  return data.adminEfpHipayVendors ?? []
}

export async function refreshAdminHipayVendor(idVendeur: number): Promise<AdminHipayVendor> {
  const data = await fetchApi<{ adminEfpRefreshHipayVendor: AdminHipayVendor }>(
    `mutation ($idVendeur: Int!) {
      adminEfpRefreshHipayVendor(idVendeur: $idVendeur) { ${vendorFields} }
    }`,
    { idVendeur },
  )
  return data.adminEfpRefreshHipayVendor
}

export async function refreshAllAdminHipayVendors(): Promise<AdminHipayVendor[]> {
  const data = await fetchApi<{ adminEfpRefreshAllHipayVendors: AdminHipayVendor[] }>(
    `mutation { adminEfpRefreshAllHipayVendors { ${vendorFields} } }`,
  )
  return data.adminEfpRefreshAllHipayVendors ?? []
}

export async function fetchAdminHipayUboStatement(
  idVendeur: number,
): Promise<AdminHipayUboStatementResult> {
  const data = await fetchApi<{
    adminEfpHipayUboStatement: AdminHipayUboStatementResult
  }>(
    `query ($idVendeur: Int!) {
      adminEfpHipayUboStatement(idVendeur: $idVendeur) {
        idVendeur email accountId payload
      }
    }`,
    { idVendeur },
  )
  return data.adminEfpHipayUboStatement
}
